"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapI18nBundle = void 0;
var bundle_1 = require("./bundle");
Object.defineProperty(exports, "getCapI18nBundle", { enumerable: true, get: function () { return bundle_1.getCapI18nBundle; } });
//# sourceMappingURL=index.js.map